import React, { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Checkbox,
  AccordionCard,
  Input,
  Field,
  Select
} from '@itds/elements/index.js';

import { AgencyContext } from '@brokerage/contexts/AgencyContext';

import { Api } from '@brokerage/utils/Api';

const Integrations = () => {
  const { agency, loadAgency } = useContext(AgencyContext);

  const [data, setData] = useState({
    applicint_password: agency.applicint_password || '',
    applicint_username: agency.applicint_username || '',
    enable_applicint: agency.enable_applicint || false,
    enable_psg_eapps: agency.enable_psg_eapps || false,
    ethos_id: agency.ethos_id || '',
    fl_client_secret: agency.fl_client_secret || '',
    fl_environment: agency.fl_environment || '',
    fl_external_map_code: agency.fl_external_map_code || '',
    fl_role_code: agency.fl_role_code || '',
    nmb_eticket_host: agency.nmb_eticket_host || '',
    nmb_eticket_url: agency.nmb_eticket_url || '',
    nmb_insureio_api_key: agency.nmb_insureio_api_key || '',
    nmb_insureio_id: agency.nmb_insureio_id || '',
    protective_agency_code: agency.protective_agency_code || '',
    protective_contract_number: agency.protective_contract_number || '',
    sbli_agency_code: agency.sbli_agency_code || '',
    sbli_contract_number: agency.sbli_contract_number || '',
    use_anico_test_servers: agency.use_anico_test_servers || false,
    use_applicint_test_servers: agency.use_applicint_test_servers || false,
    use_paclife_test_servers: agency.use_paclife_test_servers || false,
    use_protective_test_servers: agency.use_protective_test_servers || false,
    use_psg_test_servers: agency.use_psg_test_servers || false,
    use_sbli_test_servers: agency.use_sbli_test_servers || false
  });
  const [error_message, setErrorMessage] = useState();
  const [success_message, setSuccessMessage] = useState();

  useEffect(() => {
    return () => {
      setErrorMessage(null);
      setSuccessMessage(null);
    };
  }, []);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleSave = () => {
    window.scrollTo(0, 0);

    Api.updateAgency(agency.id, data)
      .then(() => {
        loadAgency(agency.id);
        setSuccessMessage('Agency updated successfully');
      })
      .catch(() => {
        setErrorMessage('Unable to update Agency');
      });
  };

  return (
    <>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <AccordionCard label='American National'>
        <Checkbox
          checked={data.use_anico_test_servers}
          label="Use American National's test servers"
          onChange={handleCheckboxChange.bind(null, 'use_anico_test_servers')}
        />
      </AccordionCard>

      <AccordionCard label='Applicint'>
        <div style={{ marginBottom: 20 }}>
          <Checkbox
            checked={data.enable_applicint}
            label='Enable Applicint integration'
            onChange={handleCheckboxChange.bind(null, 'enable_applicint')}
          />
        </div>

        {data.enable_applicint ? (
          <>
            <Field label='Applicint Agency Username'>
              <Input
                onChange={handleInputChange.bind(null, 'applicint_username')}
                style={{ width: '49%' }}
                value={data.applicint_username}
              />
            </Field>
            <Field label='Applicint Agency Password'>
              <Input
                onChange={handleInputChange.bind(null, 'applicint_password')}
                style={{ width: '49%' }}
                value={data.applicint_password}
              />
            </Field>
            <Checkbox
              checked={data.use_applicint_test_servers}
              label="Use Applicint's test servers"
              onChange={handleCheckboxChange.bind(null, 'use_applicint_test_servers')}
            />
          </>
        ) : null}
      </AccordionCard>

      <AccordionCard label='Ethos'>
        <Field label='Agency ID'>
          <Input
            onChange={handleInputChange.bind(null, 'ethos_id')}
            style={{ width: '49%' }}
            value={data.ethos_id}
          />
        </Field>
      </AccordionCard>

      <AccordionCard label='FireLight'>
        <Field label='External Map Code'>
          <Input
            onChange={handleInputChange.bind(null, 'fl_external_map_code')}
            style={{ width: '49%' }}
            value={data.fl_external_map_code}
          />
        </Field>
        <div style={{ width: '49%' }}>
          <Field label='Environment'>
            <Select
              onChange={handleInputChange.bind(null, 'fl_environment')}
              options={[
                { value: 'flqa.insurancetechnologies.com/EGApp/', label: 'QE' },
                { value: 'flqanext.insurancetechnologies.com/EGApp/', label: 'QE Next' },
                { value: 'uat.firelighteapp.com/EGApp/', label: 'UAT' },
                { value: 'uat.firelighteapp.com/EGAppnext/', label: 'UAT Next' },
                { value: 'staging.firelighteapp.com/EGApp/', label: 'Staging' },
                { value: 'www.firelighteapp.com/EGApp/', label: 'Production' }
              ]}
              value={data.fl_environment}
            />
          </Field>
        </div>
        <Field label='Client Secret'>
          <Input
            onChange={handleInputChange.bind(null, 'fl_client_secret')}
            style={{ width: '49%' }}
            value={data.fl_client_secret}
          />
        </Field>
        <Field label='Role Code'>
          <Input
            onChange={handleInputChange.bind(null, 'fl_role_code')}
            style={{ width: '49%' }}
            value={data.fl_role_code}
          />
        </Field>
      </AccordionCard>

      <AccordionCard label='National Mutual Benefit'>
        <Field label='E-Ticket Insureio Host'>
          <Input
            onChange={handleInputChange.bind(null, 'nmb_eticket_host')}
            style={{ width: '49%' }}
            value={data.nmb_eticket_host}
          />
        </Field>
        <Field label='E-Ticket Insureio URL'>
          <Input
            onChange={handleInputChange.bind(null, 'nmb_eticket_url')}
            style={{ width: '49%' }}
            value={data.nmb_eticket_url}
          />
        </Field>
        <Field label='E-Ticket Insureio API Key'>
          <Input
            onChange={handleInputChange.bind(null, 'nmb_insureio_api_key')}
            style={{ width: '49%' }}
            value={data.nmb_insureio_api_key}
          />
        </Field>
        <Field label='E-Ticket Insureio'>
          <Input
            onChange={handleInputChange.bind(null, 'nmb_insureio_id')}
            style={{ width: '49%' }}
            value={data.nmb_insureio_id}
          />
        </Field>
      </AccordionCard>

      <AccordionCard label='Pacific Life'>
        <Checkbox
          checked={data.use_paclife_test_servers}
          label="Use Paclife's test servers"
          onChange={handleCheckboxChange.bind(null, 'use_paclife_test_servers')}
        />
      </AccordionCard>

      <AccordionCard label='Paperless Solutions Group'>
        <Checkbox
          checked={data.enable_psg_eapps}
          label='Enable PSG E-Apps Integration'
          onChange={handleCheckboxChange.bind(null, 'enable_psg_eapps')}
        />
        <Checkbox
          checked={data.use_psg_test_servers}
          label="Use PSG's test servers"
          onChange={handleCheckboxChange.bind(null, 'use_psg_test_servers')}
        />
      </AccordionCard>

      <AccordionCard label='Protective'>
        <Field label='Protective Agency Code'>
          <Input
            onChange={handleInputChange.bind(null, 'protective_agency_code')}
            style={{ width: '49%' }}
            value={data.protective_agency_code}
          />
        </Field>
        <Field label='Protective Contract Number'>
          <Input
            onChange={handleInputChange.bind(null, 'protective_contract_number')}
            style={{ width: '49%' }}
            value={data.protective_contract_number}
          />
        </Field>
        <Checkbox
          checked={data.use_protective_test_servers}
          label="Use Protective's test servers"
          onChange={handleCheckboxChange.bind(null, 'use_protective_test_servers')}
        />
      </AccordionCard>

      <AccordionCard label='SBLI'>
        <Field label='SBLI Agency Code'>
          <Input
            onChange={handleInputChange.bind(null, 'sbli_agency_code')}
            style={{ width: '49%' }}
            value={data.sbli_agency_code}
          />
        </Field>
        <Field label='SBLI Contract Number'>
          <Input
            onChange={handleInputChange.bind(null, 'sbli_contract_number')}
            style={{ width: '49%' }}
            value={data.sbli_contract_number}
          />
        </Field>
        <Checkbox
          checked={data.use_sbli_test_servers}
          label="Use SBLI's test servers"
          onChange={handleCheckboxChange.bind(null, 'use_sbli_test_servers')}
        />
      </AccordionCard>

      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <Button onClick={handleSave}>Save Changes</Button>
      </div>
    </>
  );
};

export default Integrations;
